var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 135.909 136.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(-1998.789 -200.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M2101.4,259.965a32.149,32.149,0,0,1-14.838,35.119c-11.34,6.763-24.841,5.328-33.535-.875,1.388-2.16,3.711-5.95,4.962-7.891,1.644.763,3.17,1.6,4.795,2.2a21.974,21.974,0,0,0,26.1-9.057c3.667-5.981,4.622-12.374,2.336-19-2.8-8.124-8.611-13.06-17.009-14.858a20.708,20.708,0,0,0-13.384,1.563,22.849,22.849,0,0,0-11.874,12.978c-.362.941-.593,1.934-.875,2.908l12.595,5.616-21.625,7.812-9.522-20.171-.252-.625,4.439,2.08.2.081c1.633.932,3.435,1.647,5.217,2.666.055-.254.116-.508.173-.758a30.4,30.4,0,0,1,14.6-19.949,31.067,31.067,0,0,1,19.927-4.207A32.061,32.061,0,0,1,2101.4,259.965Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M2134.7,268.157a67.954,67.954,0,1,1-69.044-68.069A67.939,67.939,0,0,1,2134.7,268.157Zm-10.707.03a57.258,57.258,0,1,0-56.858,57.374A57.135,57.135,0,0,0,2123.99,268.187Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/restore-icon.340a881bc36d3056bc1a097a6ded10bc.svg";
export { ForwardRef as ReactComponent };